import { useLazyDataModel } from '@thd-nucleus/data-sources';
import { useConfigService } from '@thd-nucleus/experience-context';
import {
  getItemId,
  getMcvisID,
  getPageType,
  getRecentSearchTerms,
  getSvocId,
} from '../utils/window-utils';
import { isAPI } from '../components/MagicApronAssistant/constants';

/**
 * @returns {[
 *   ({ userQuestion: string }) => void,
 *   { data: object, loading: boolean, error: string }
 * ]}
 */
export const useGenerateQuestions = (session) => {
  const llmNameFS = useConfigService('fs:magic-apron-generate-questions-llm') || 'pro002';
  const [submitToBot, response] = useLazyDataModel('generateQuestions', {
    lazy: true,
  });
  const submitToGenerateQuestions = (params) => {
    const {
      isConsumerApp,
      channel,
      deliveryZip,
      storeId
    } = params;
    submitToBot({ variables: {
      userContext: {
        userIdentities: {
          mcvisId: getMcvisID(),
          svocId: getSvocId(),
        },
        sessionId: session.sessionId,
        storeId,
        zipCode: deliveryZip,
        deviceType: channel === 'mobile' && isConsumerApp ? 'app' : channel,
        language: 'en-US',
      },
      pageContext: {
        pageType: getPageType(isAPI),
        referrerPage: window.document.referrer,
        timestamp: Date.now(),
        url: window.parent.location.href,
      },
      questionContext: {
        userQuestion: '',
        user_typed: 'N|null',
        itemId: getItemId(),
        recentSearchTerms: getRecentSearchTerms(),
      },
      suggestedQuestions: true,
      followUpQuestions: false,
      model_name: llmNameFS,
    } });
  };

  return [
    submitToGenerateQuestions,
    response,
  ];
};
